import React from "react";
import { BodyBuilder } from "../../../exports/Images";
// import SelectDropdown from "../../components-react/SelectDropdown";

const UserInfo = ({ userData }) => {
  // const isClusterManager = userData?.account_type === "cluster_manager";
  // const clusterGyms =
  //   userData?.account_type === "cluster_manager" && userData?.gyms
  //     ? userData.gyms?.gyms || []
  //     : [];

  // const [selectedGym, setSelectedGym] = useState(() => {
  //   const savedGymId = localStorage.getItem("selectedGym");
  //   if (savedGymId) {
  //     const savedGym = clusterGyms.find((gym) => gym.value === savedGymId);
  //     return (
  //       savedGym ||
  //       (isClusterManager && clusterGyms?.length > 0 ? clusterGyms[0] : "")
  //     );
  //   }
  //   return isClusterManager && clusterGyms?.length > 0 ? clusterGyms[0] : "";
  // });

  // const handleGymChange = (selectedValue) => {
  //   setSelectedGym(selectedValue);
  // };

  return (
    <div className="open-pages-container">
      <div className="user-profile-container">
        <div className="user-profile-sec user-profile-img">
          <img
            src={userData?.profile || BodyBuilder}
            alt={userData?.name || ""}
            className="user-image"
          />
        </div>

        <div className="user-profile-sec user-profile-details">
          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Name</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{userData?.name || "NA"}</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Mobile</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{userData?.mobile || "NA"}</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">email</p>
            </div>
            <div className="user-details-info">
              <p
                className="info-name"
                style={{
                  textTransform: `${
                    userData?.email ? "lowercase" : "capitialize"
                  }`,
                }}>
                {userData?.email || "NA"}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">gym name</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{userData?.gym_name || "NA"}</p>
              {/* {isClusterManager ? (
                <div
                  className={`custom-sidebar-header-searchbar ${
                    selectedGym?.value ? "with-value" : ""
                  }`}
                >
                  <div className="commonWrapper">
                    <SelectDropdown
                      options={clusterGyms}
                      selectedOption={selectedGym}
                      setSelectedOption={(selectedValue) =>
                        handleGymChange(selectedValue)
                      }
                      name="Gym"
                    />
                  </div>
                </div>
              ) : (
                <p className="info-name">{userData?.gym_name || "NA"}</p>
              )} */}
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">account type</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {userData?.account_type === "receptionist"
                  ? "Sales Executive"
                  : userData?.account_type?.replace(/_/g, " ") || "NA"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserInfo;
